<script setup>
import Icon from './Icon.vue'
import Button from './Button.vue'
import Prompt from '@utils/Prompt.js'

window.addEventListener('keydown', (e) => {
    // close prompt if click keyboard esc
    if (e.key === 'Escape') Prompt.close()
})
</script>

<template>
    <div class="fixed top-0 left-0 z-[200] flex items-center justify-center w-full h-full" v-if="Prompt.visible.value">
        <div v-if="Prompt.close" class="absolute left-0 top-0 w-full h-full bg-[rgba(0,0,0,0.5)] z-0" @click="Prompt.close"></div>
        <div @click.stop class="z-50 prebook-animate-prompt">
            <div class="bg-[white] rounded-lg p-4 flex gap-4">
                <div v-if="Prompt.details.value.icon" class="bg-[#FFFAEE] w-14 h-14 rounded-full flex items-center justify-center">
                    <Icon :name="Prompt.details.value.icon" size="40px" class="text-[#D06B0F] bg-[#FEEFC6] rounded-full p-2" />
                </div>
                <div>
                    <div v-if="Prompt.details.value.title" class="font-semibold text-lg mb-1 text-[#0F1523]" v-html="Prompt.details.value.title"></div>
                    <div v-if="Prompt.details.value.message" class="text-[#6D6F7B] text-sm" v-html="Prompt.details.value.message"></div>

                    <div class="flex items-center gap-4 mt-8">
                        <Button v-if="Prompt.details.value.cancel" @click.stop="Prompt.close('close')" type="primary" radius="square" size="sm" class="bg-[#D92D21] border-[#D92D21] hover:bg-[#eb281a]">{{ Prompt.details.value.cancel }}</Button>
                        <Button v-if="Prompt.details.value.ok" @click.stop="Prompt.close('ok')" type="primary" radius="square" size="sm">{{ Prompt.details.value.ok }}</Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.prebook-animate-prompt {
    animation: prompt 0.4s ease-in-out;
}

@keyframes prompt {
    0% {
        transform: scale(0.7);
        opacity: 0;
    }
    45% {
        transform: scale(1.05);
        opacity: 1;
    }
    80% {
        transform: scale(0.95);
    }
    100% {
        transform: scale(1);
    }
}


</style>
